import { useEffect, useState } from 'react';

interface WhoamiResponse {
  last_login_mode?: 'mos-oidc' | 'local-fallback' | 'legacy';
}

export function OfflineBanner(): React.ReactElement | null {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch('/auth/whoami', { credentials: 'include' })
      .then(r => (r.ok ? r.json() : Promise.resolve(null)))
      .then((s: WhoamiResponse | null) => {
        if (!cancelled) setShow(s?.last_login_mode === 'local-fallback');
      })
      .catch(() => {
        // Whoami unreachable → assume not in local-fallback (don't render banner)
      });
    return (): void => {
      cancelled = true;
    };
  }, []);

  if (!show) return null;
  return (
    <div className="border-b border-border bg-warning px-4 py-2 text-center text-sm font-semibold text-background">
      ⚠ OFFLINE — fallback authentication. Audit events are queued for MOS sync.
    </div>
  );
}
